// import axios from "axios";
// import { store } from "../app/store";
// import { hasCoords, readStoredLocation } from "../utils/googleLocation";
// let setGlobalLoading;
// let activeRequests = 0;
// let loaderTimeout = null;
// export const setLoader = (setLoading) => {
//   setGlobalLoading = setLoading;
// };
// const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();
// const isLocalHost =
//   typeof window !== "undefined" &&
//   ["localhost", "127.0.0.1"].includes(window.location.hostname);
// const localBaseUrl = "https://mdk7v2f6-5000.inc1.devtunnels.ms";
// const remoteBaseUrl = "https://mdk7v2f6-5000.inc1.devtunnels.ms";

// export const REAL_BASE_URL = isLocalHost
//   ? localBaseUrl
//   : configuredBaseUrl || remoteBaseUrl;
// const BASE_URL = REAL_BASE_URL;


//    export  const RD_URL = process.env.REACT_RD_API_BASE_URL || "https://mdk7v2f6-5000.inc1.devtunnels.ms";

// const axiosInstance = axios.create({
//   baseURL: BASE_URL,
//   timeout: 30000,
// });

// function currentGeo() {
//   const loc = store.getState()?.auth?.location || readStoredLocation();
//   if (!hasCoords(loc)) return null;
//   return {
//     latitude: String(loc.latitude),
//     longitude: String(loc.longitude),
//   };
// }

// axiosInstance.interceptors.request.use((config) => {
//   activeRequests += 1;

//     if (!loaderTimeout) {
//       loaderTimeout = setTimeout(() => {
//         if (setGlobalLoading) setGlobalLoading(true);
//       }, 150);
//     }

//   const state = store.getState();
//   const token =
//     state?.auth?.token ||
//     localStorage.getItem("token") ||
//     localStorage.getItem("authToken");

//   config.headers["X-App-Client"] = "merchant";
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }

//   const geo = currentGeo();
//   if (geo) {
//     config.headers["X-Latitude"] = geo.latitude;
//     config.headers["X-Longitude"] = geo.longitude;
//     config.headers["X-Request-Source"] = "WEB";
//     config.params = {
//       ...(config.params || {}),
//       latitude: geo.latitude,
//       longitude: geo.longitude,
//     };
//     if (
//       config.data &&
//       typeof config.data === "object" &&
//       !(config.data instanceof FormData)
//     ) {
//       if (config.data.latitude == null) config.data.latitude = Number(geo.latitude);
//       if (config.data.longitude == null) config.data.longitude = Number(geo.longitude);
//     }
//   }

//   // ❌ DO NOT set multipart manually
//   if (!(config.data instanceof FormData)) {
//     config.headers["Content-Type"] = "application/json";
//   }

//   const pipe = state.aeps.pipe;
//   if (pipe && config.data) {
//     // config.data.pipe = pipe;
//     if (pipe) {
//   if (config.data instanceof FormData) {
//     config.data.append("pipe", pipe);
//   } else {
//     config.data.pipe = pipe;
//   }
// }
//   }

//   return config;
// });

// axiosInstance.interceptors.response.use(
//   (response) => {
//     activeRequests -= 1;
//     if (activeRequests === 0) {
//       clearTimeout(loaderTimeout);
//       loaderTimeout = null;
//       if (setGlobalLoading) setGlobalLoading(false);
//     }
//     return response;
//   },
//   (error) => {
//     activeRequests -= 1;
//     if (activeRequests === 0) {
//       clearTimeout(loaderTimeout);
//       loaderTimeout = null;
//       if (setGlobalLoading) setGlobalLoading(false);
//     }
//     if (error?.response?.status === 401) {
//       localStorage.removeItem("authToken");
//       localStorage.removeItem("token");
//       localStorage.removeItem("userInfo");
//     }
//     return Promise.reject(error);
//   }
// );
// export default axiosInstance;





// import axios from "axios";
// import { store } from "../app/store";
// let setGlobalLoading;
// let activeRequests = 0;
// let loaderTimeout = null;
// export const setLoader = (setLoading) => {
//   setGlobalLoading = setLoading;
// };
// const BASE_URL =
//   process.env.REACT_APP_API_BASE_URL || "https://mdk7v2f6-5000.inc1.devtunnels.ms";
//  export  const REAL_BASE_URL =
//   process.env.REACT_APP_API_BASE_URL || "https://mdk7v2f6-5000.inc1.devtunnels.ms";


//    export  const RD_URL =
//   process.env.REACT_RD_API_BASE_URL || "https://mdk7v2f6-5000.inc1.devtunnels.ms";

// const axiosInstance = axios.create({
//   baseURL: BASE_URL,
//   timeout: 30000,
// });
// axiosInstance.interceptors.request.use((config) => {
//   // 🔑 default true
//   const showLoader = config.meta?.showLoader !== false;

//   if (showLoader) {
//     activeRequests++;

//     if (!loaderTimeout) {
//       loaderTimeout = setTimeout(() => {
//         setGlobalLoading?.(true);
//       }, 150);
//     }
//   }

//   const state = store.getState();
//   const token =
//     state?.auth?.token ||
//     localStorage.getItem("token") ||
//     localStorage.getItem("authToken");

//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }

//   config.headers["Content-Type"] =
//     config.data instanceof FormData
//       ? "multipart/form-data"
//       : "application/json";

//   return config;
// });

// axiosInstance.interceptors.response.use(
//   (response) => {
//     if (response.config.meta?.showLoader !== false) {
//       activeRequests--;
//       if (activeRequests === 0) {
//         clearTimeout(loaderTimeout);
//         loaderTimeout = null;
//         setGlobalLoading?.(false);
//       }
//     }
//     return response;
//   },
//   (error) => {
//     if (error.config?.meta?.showLoader !== false) {
//       activeRequests--;
//       if (activeRequests === 0) {
//         clearTimeout(loaderTimeout);
//         loaderTimeout = null;
//         setGlobalLoading?.(false);
//       }
//     }

//     // ❌ DON'T NOTIFY ALL ERRORS
//     const silent = error.config?.meta?.silentError;

//     if (!silent) {
//       const message =
//         error.response?.data?.message || "Something went wrong";

//       window.dispatchEvent(
//         new CustomEvent("GLOBAL_ERROR", { detail: message })
//       );
//     }

//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;





import axios from "axios";
import { store } from "../app/store";
import { hasCoords, readStoredLocation } from "../utils/googleLocation";
import { logout } from "../features/authSlice";

let setGlobalLoading;
let activeRequests = 0;
let loaderTimeout = null;
let refreshPromise = null;

export const setLoader = (setLoading) => {
  setGlobalLoading = setLoading;
};

// ============================================================
// API BASE URL
// ============================================================
// .env is the ONLY source of truth.
//
// Development:
// REACT_APP_API_BASE_URL=https://mdk7v2f6-5000.inc1.devtunnels.ms
//
// Production:
// REACT_APP_API_BASE_URL=https://mdk7v2f6-5000.inc1.devtunnels.ms
// ============================================================

const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();

export const REAL_BASE_URL = configuredBaseUrl;

const BASE_URL = REAL_BASE_URL;

export const RD_URL = process.env.REACT_RD_API_BASE_URL?.trim();

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  withCredentials: true,
});

const readCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

// ============================================================
// CURRENT GEO LOCATION
// ============================================================

function currentGeo() {
  const loc = store.getState()?.auth?.location || readStoredLocation();

  if (!hasCoords(loc)) {
    return null;
  }

  return {
    latitude: String(loc.latitude),
    longitude: String(loc.longitude),
  };
}

// ============================================================
// REQUEST INTERCEPTOR
// ============================================================

axiosInstance.interceptors.request.use(
  (config) => {
    const showLoader = config.meta?.showLoader !== false;
    if (showLoader) {
      activeRequests += 1;

      if (!loaderTimeout) {
        loaderTimeout = setTimeout(() => {
          if (setGlobalLoading) {
            setGlobalLoading(true);
          }
        }, 150);
      }
    }

    const state = store.getState();

    // ----------------------------------------------------------
    // APP CLIENT
    // ----------------------------------------------------------

    config.headers = config.headers || {};

    config.headers["X-App-Client"] = "merchant";

    // ----------------------------------------------------------
    // AUTHORIZATION
    // ----------------------------------------------------------

    const csrfToken = readCookie("ezypay_csrf");
    if (csrfToken && !["get", "head", "options"].includes(config.method?.toLowerCase())) {
      config.headers["X-CSRF-Token"] = csrfToken;
    }

    // ----------------------------------------------------------
    // GEO LOCATION
    // ----------------------------------------------------------

    // const geo = currentGeo();

    // if (geo) {
    //   config.headers["X-Latitude"] = geo.latitude;
    //   config.headers["X-Longitude"] = geo.longitude;
    //   config.headers["X-Request-Source"] = "WEB";

    //   config.params = {
    //     ...(config.params || {}),
    //     latitude: geo.latitude,
    //     longitude: geo.longitude,
    //   };

    //   if (
    //     config.data &&
    //     typeof config.data === "object" &&
    //     !(config.data instanceof FormData)
    //   ) {
    //     if (config.data.latitude == null) {
    //       config.data.latitude = Number(geo.latitude);
    //     }

    //     if (config.data.longitude == null) {
    //       config.data.longitude = Number(geo.longitude);
    //     }
    //   }
    // }

    const skipGeoBody = config.skipGeoBody === true;
    delete config.skipGeoBody;
    const geo = currentGeo();

    if (geo) {
      config.headers["X-Latitude"] = geo.latitude;
      config.headers["X-Longitude"] = geo.longitude;
      config.headers["X-Request-Source"] = "WEB";

      if (config.data instanceof FormData) {
        if (typeof config.data.set === "function") {
          config.data.set("latitude", geo.latitude);
          config.data.set("longitude", geo.longitude);
        } else {
          config.data.append("latitude", geo.latitude);
          config.data.append("longitude", geo.longitude);
        }
      } else if (
        !skipGeoBody &&
        config.data &&
        typeof config.data === "object"
      ) {
        config.data = {
          ...config.data,
          latitude: geo.latitude,
          longitude: geo.longitude,
        };
      }
    }

    // ----------------------------------------------------------
    // CONTENT TYPE
    // ----------------------------------------------------------
    // Do NOT manually set multipart/form-data.
    // Browser will automatically set the correct boundary.
    // ----------------------------------------------------------

    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }

    // ----------------------------------------------------------
    // AEPS PIPE
    // ----------------------------------------------------------

    const pipe = state?.aeps?.pipe;

    if (pipe && config.data) {
      if (config.data instanceof FormData) {
        config.data.append("pipe", pipe);
      } else {
        config.data.pipe = pipe;
      }
    }

    return config;
  },
  (error) => {
    if (error.config?.meta?.showLoader !== false) {
      activeRequests = Math.max(0, activeRequests - 1);

      if (activeRequests === 0) {
        clearTimeout(loaderTimeout);
        loaderTimeout = null;

        if (setGlobalLoading) {
          setGlobalLoading(false);
        }
      }
    }

    return Promise.reject(error);
  }
);

// ============================================================
// RESPONSE INTERCEPTOR
// ============================================================

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.config?.meta?.showLoader !== false) {
      activeRequests = Math.max(0, activeRequests - 1);

      if (activeRequests === 0) {
        clearTimeout(loaderTimeout);
        loaderTimeout = null;

        if (setGlobalLoading) {
          setGlobalLoading(false);
        }
      }
    }

    return response;
  },
  async (error) => {
    if (error.config?.meta?.showLoader !== false) {
      activeRequests = Math.max(0, activeRequests - 1);

      if (activeRequests === 0) {
        clearTimeout(loaderTimeout);
        loaderTimeout = null;

        if (setGlobalLoading) {
          setGlobalLoading(false);
        }
      }
    }

    // ----------------------------------------------------------
    // UNAUTHORIZED
    // ----------------------------------------------------------

    const request = error.config;
    const isRefreshRequest = request?.url?.includes("/api/auth/refresh");
    const isSessionCheck = request?.url?.includes("/api/auth/session");
    const isAuthRequest = request?.url?.includes("/api/auth/login") ||
      request?.url?.includes("/api/auth/verify/mpin");

    if (error?.response?.status === 401 && request && !request._authRetry && !request._skipAuthRetry && !isRefreshRequest && !isSessionCheck && !isAuthRequest) {
      if (!refreshPromise) {
        refreshPromise = axiosInstance
          .post("/api/auth/refresh", null, { _authRetry: true, meta: { silentError: true } })
          .finally(() => {
            refreshPromise = null;
          });
      }

      try {
        await refreshPromise;
        return axiosInstance({ ...request, _authRetry: true });
      } catch (refreshError) {
        const code = refreshError?.response?.data?.code;
        if (code === "AUTH_SESSION_EXPIRED_7D" || code === "AUTH_SESSION_REVOKED") {
          store.dispatch(logout());
        }
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
